<google-map *ngIf="center && mapOptions" [center]="center" width="100%" [height]="height" [options]=" mapOptions">
  <app-polygonos [ubicaciones]="otrasUbicaciones" [cLinea]="cLinea" [cRelleno]="cRelleno"
    [opacidad]="opacidad"></app-polygonos>

  <ng-container *ngIf="!esPolyline">
    <ng-container *ngFor="let polygon of polygonOptions; let i = index">
      <map-polygon [options]="polygon" (polygonClick)="handlePolygonClick($event, polygon)"></map-polygon>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="esPolyline">
    <ng-container *ngFor="let polyline of polylineOptions; let i = index">
      <map-polyline [options]="polyline" (polylineClick)="handlePolylineClick($event, polyline)"></map-polyline>
    </ng-container>
  </ng-container>

  <map-info-window style="max-width: 100%;" #infoWindow="mapInfoWindow">
    <div class="info-window">
      <div class="info-titulo">
        <p>
          {{ambiente?.nombre}}
        </p>
      </div>
      <div class="info-subtitulo">
        <p>{{ ambiente?.establecimiento?.nombre }}</p>
      </div>
      <div class="item-list-container">
        <div *ngFor="let sensorHumedadSuelo of ambiente?.sensorHumedadSuelos">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Sensores de Humedad de Suelo">
              <mat-icon svgIcon="shss" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ sensorHumedadSuelo?.nombre }}</p>
              <span class="mini-text"> {{sensorHumedadSuelo?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{sensorHumedadSuelo.ultimoReporte?.reporte?.humedad}}% <span class="mini-text">Humedad</span></p>
              <p>{{sensorHumedadSuelo.ultimoReporte?.reporte?.temperatura}}c°
                <span class="mini-text">Temperatura</span>
              </p>
            </div>
          </div>
        </div>
        <div *ngFor="let pluviometro of ambiente?.pluviometros">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Pluviometros">
              <mat-icon svgIcon="pluviometros" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ pluviometro?.nombre }}</p>
              <span class="mini-text"> {{pluviometro?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{ pluviometro.ultimoReporte?.reporte?.valorAcumulado?.toFixed(2) }}mm <span
                  class="mini-text">Acumulado</span></p>
              <p>{{pluviometro.ultimoReporte?.reporte?.valorInstantaneo}}mm <span class="mini-text">Instantaneo</span>
              </p>
            </div>
          </div>
        </div>
        <div *ngFor="let freatimetro of ambiente?.freatimetros">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Freatimetros">
              <mat-icon svgIcon="freatimetros" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ freatimetro?.nombre }}</p>
              <span class="mini-text"> {{freatimetro?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{freatimetro.ultimoReporte?.reporte?.nivel}}cm <span class="mini-text">Nivel Napa</span></p>
            </div>
          </div>
        </div>
        <div *ngFor="let estacionMeteorologica of ambiente?.estacionMeteorologicas">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Est. Meteorológicas">
              <mat-icon svgIcon="meteorologicas" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ estacionMeteorologica?.nombre }}</p>
              <span class="mini-text"> {{estacionMeteorologica?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </div>
            <div class="alertas-container">
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.temperatura}}c°
                <span class="mini-text">Temperatura</span>
              </p>
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.humedad}}%
                <span class="mini-text">Humedad</span>
              </p>
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.presion}}
                <span class="mini-text">Presión Atm.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </map-info-window>
</google-map>

<div class="btn-crear" *ngIf="editable">
  <!-- Agregar Poligono -->
  <button *ngIf="mostrarCrear()" class="mx-2" type="button" mat-fab [matTooltip]="'Crear'" [color]="'accent'"
    (click)="dibujar()">
    <mat-icon>add</mat-icon>
  </button>

  <!-- Cancelar -->
  <button *ngIf="dibujando" class="mx-2" type="button" mat-fab [matTooltip]="'Cancelar'" [color]="'warn'"
    (click)="cancelarDibujo()">
    <mat-icon>clear</mat-icon>
  </button>
</div>